/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetIncidentsListRequest} from '@cash-web/protos/squareup/cash/incidentalerts/app/v1/app.pb'
import {GetIncidentsListResponse} from '@cash-web/protos/squareup/cash/incidentalerts/app/v1/app.pb'


export const getIncidentsList = (request: GetIncidentsListRequest, options?: CashRequestOptions) => post<GetIncidentsListRequest, GetIncidentsListResponse>("/cash-app/incident-alerts/get-incidents", request, {...options, rejectOnError: true })